import React, { useState, useRef, useEffect, useMemo } from "react";
import "../../css/MFManagement/MFManagement.css";
import { NavLink, useLocation } from "react-router-dom";
import MFRoutes from "./MFRoutes";
import { ArrowDown2, ArrowUp2 } from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";

const menu_array = [
  {
    name: "Portfolio",
    path: "/account/mf/portfolio",
  },
  {
    name: "SIP",
    path: "/account/mf/sip",
  },
  {
    name: "Transactions",
    path: "/account/mf/transaction",
  },
  {
    name: "SIP Transactions",
    path: "/account/mf/siptransaction",
  },
  {
    name: "Account",
    path: "/account/mf/clientaccount",
  },
  {
    name: "Watchlist",
    path: "/account/mf/watchlist",
  },
  // {
  //   name: "Filter MF",
  //   path: "/account/mf/filter",
  // },
];

function MFMenu() {
  const location = useLocation();
  const { pathname = "" } = location;
  const ref = useRef();

  const [menu, setMenu] = useState("Portfolio");
  const [menuPopup, setMenuPopup] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setMenuPopup(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const menu_item = menu_array.find((m) => m.path === pathname);
    if (menu_item) {
      setMenu(menu_item.name);
    }
  }, []);

  function NavLinkCallback(menu_item) {
    setMenu(menu_item);
    setMenuPopup(false);
  }

  return (
    <>
      <div
        className="swift-submenu-item"
        onClick={() => {
          setMenuPopup(!menuPopup);
        }}
      >
        <p>{menu}</p>
        {menuPopup ? (
          <>
            <ArrowUp2 size={18} color={COLOR_VARS["SWIFT_COLOR1"]} />
          </>
        ) : (
          <>
            <ArrowDown2 size={18} color={COLOR_VARS["SWIFT_COLOR1"]} />
          </>
        )}
      </div>
      <div ref={ref} className={"swift-submenu " + (menuPopup ? "active" : "")}>
        {menu_array.map((m, index) => {
          return (
            <NavLink
              key={index}
              to={`${m.path}`}
              onClick={() => {
                NavLinkCallback(m.name);
              }}
            >
              <p className={pathname === m.path ? "active" : ""}>{m.name}</p>
            </NavLink>
          );
        })}
      </div>
    </>
  );
}

function MFManagement() {

  return (
    <div className="swift-mf-management swift-content">
      <div className="swift-submenu-wrapper">
        <MFMenu />
      </div>

      <div className="strategy-content">
        <MFRoutes />
      </div>
    </div>
  );
}

export default MFManagement;
